import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import * as React from "react";

export enum SearchSortType {
  Relevancy = "Relevancy",
  Title = "Title",
  Author = "Author",
  PubDate = "PubDate",
  Rating = "Rating",
  NewlyAdded = "NewlyAdded",
  CallNumber = "CallNumber",
}

export enum ListSortType {
  Title = "Title",
  Author = "Author",
  PubDate = "PubDate",
  CallNumber = "CallNumber",
}

export const SavedListSortControl: React.FC<SelectProps> = (props) => {
  const { translate } = useLanguage();
  return (
    <FormControl>
      <InputLabel id="list-sort-label">{translate("sortBy")}</InputLabel>
      <Select
        size="small"
        labelId="list-sort-label"
        label={translate("sortBy")}
        inputProps={{
          "aria-labelledby": "list-sort-label",
        }}
        {...props}
      >
        <MenuItem value={ListSortType.Title}>{translate("title")}</MenuItem>
        <MenuItem value={ListSortType.Author}>{translate("author")}</MenuItem>
        <MenuItem value={ListSortType.PubDate}>
          {translate("publicationDate")}
        </MenuItem>
        <MenuItem value={ListSortType.CallNumber}>
          {translate("localCallNumber")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
